import type { Key9Puzzle } from '../types/puzzle';

export function validatePuzzleShape(puzzle: Key9Puzzle): string[] {
  const errors: string[] = [];
  if (puzzle.puzzle.length !== 81) errors.push('puzzle must have 81 characters');
  if (puzzle.solution.length !== 81) errors.push('solution must have 81 characters');
  if (puzzle.keyCells.length !== 9) errors.push('keyCells must contain exactly 9 cells');
  if (puzzle.keyTiles.length !== 9) errors.push('keyTiles must contain exactly 9 tiles');
  if (puzzle.keyTiles.join(',') !== '1,2,3,4,5,6,7,8,9') {
    errors.push('keyTiles must be exactly 1 through 9');
  }
  for (const cell of puzzle.keyCells) {
    if (cell < 0 || cell > 80) errors.push(`keyCell out of range: ${cell}`);
    if (puzzle.puzzle[cell] !== '0') errors.push(`keyCell must be empty in puzzle: ${cell}`);
  }
  if (puzzle.solution.length === 81 && puzzle.keyCells.length === 9) {
    const keyDigits = puzzle.keyCells
      .map((cell) => Number(puzzle.solution[cell]))
      .sort((a, b) => a - b);
    if (keyDigits.join(',') !== '1,2,3,4,5,6,7,8,9') {
      errors.push('keyCells must map to solution digits 1 through 9 exactly once');
    }
  }
  return errors;
}

export function isCorrectPlacement(puzzle: Key9Puzzle, cellIndex: number, digit: number): boolean {
  return puzzle.solution[cellIndex] === String(digit);
}

export function classifyResult(misses: number, hints: number, completed: boolean) {
  if (!completed) return 'missed' as const;
  if (hints > 0) return 'assisted_unlock' as const;
  if (misses === 0) return 'clean_unlock' as const;
  return 'unlocked' as const;
}

export function resultLabel(status: ReturnType<typeof classifyResult>): string {
  switch (status) {
    case 'clean_unlock': return 'Clean Unlock';
    case 'unlocked': return 'Unlocked';
    case 'assisted_unlock': return 'Assisted Unlock';
    case 'missed': return 'Missed';
  }
}
